import React from "react";
import { useTranslation } from "react-i18next";

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "20px", lineHeight: "1.6" }}>
      
      <h1>{t("privacy.title")}</h1>

      <p><strong>{t("privacy.lastUpdated")}</strong></p>

      <section>
        <h2>{t("privacy.sections.intro.title")}</h2>
        <p>{t("privacy.sections.intro.text")}</p>
      </section>

      <section>
        <h2>{t("privacy.sections.data.title")}</h2>
        <p>{t("privacy.sections.data.text")}</p>
      </section>

      <section>
        <h2>{t("privacy.sections.usage.title")}</h2>
        <p>{t("privacy.sections.usage.text")}</p>
      </section>

      <section>
        <h2>{t("privacy.sections.thirdParty.title")}</h2>
        <p>{t("privacy.sections.thirdParty.text")}</p>
      </section>

      <section>
        <h2>{t("privacy.sections.contact.title")}</h2>
        <p>{t("privacy.sections.contact.text")}</p>
      </section>

    </div>
  );
}
